module.exports = "pegasus/assets/theme4/google-icon.png";